import * as Yup from 'yup';
import { requiredField } from 'utils/string';
import { t } from 'utils/i18n';

export const validationSchema = Yup.object().shape({
  content: Yup.string().required(requiredField('taskName')),
  type: Yup.number().required(requiredField('type')),
  assignees: Yup.array()
    .of(
      Yup.object().shape({
        id: Yup.string(),
        name: Yup.string(),
      }),
    )
    .min(1, t('requiredAtLeastOneAssignee'))
    .required(t('requiredAtLeastOneAssignee')),
  due: Yup.date().required(requiredField('due')),
  priority: Yup.number().required(requiredField('priority')),
});
